import { EventListener } from "./EventListener";
const globalListeners = [];
class EventsManagerClass {
    constructor() {
        this._listeners = [];
    }
    addEventListener(type, context, callback, global) {
        let listeners = global ? globalListeners : this._listeners;
        if (listeners.filter(listener => listener.type === type).map(listener => listener.callback).indexOf(callback) === -1) {
            listeners.push(new EventListener(type, callback, context));
        }
    }
    removeEventListener(type, context, global) {
        let listeners = global ? globalListeners : this._listeners;
        let index = -1;
        for (let i = 0, listenersLength = listeners.length; i < listenersLength; i += 1) {
            let currentListener = listeners[i];
            if (currentListener.type === type && currentListener.context === context) {
                index = i;
                break;
            }
        }
        if (index !== -1) {
            listeners.splice(index, 1);
        }
    }
    dispatchEvent(type, data, global) {
        let listeners = global ? globalListeners : this._listeners;
        for (let i = 0; i < listeners.length; i += 1) {
            let currentListener = listeners[i];
            if (currentListener.type === type) {
                currentListener.callback.call(currentListener.context, data);
            }
        }
    }
    getGlobalEventListeners() {
        return globalListeners;
    }
}
export const EventsManager = typeof window["EventsManager"] === "undefined" ? EventsManagerClass : window["EventsManager"];
window["EventsManager"] = EventsManager;
//# sourceMappingURL=EventsManager.js.map